import { httpRequest } from "@services/http";
import { ApprovedUrl } from "@models/approvedUrl.model";

export interface CreateApprovedUrlPayload {
  url: string;
  title?: string;
  description?: string | null;
  is_active?: boolean;
}

export class CommandCreateApprovedUrl {
  async run(organizationId: number, payload: CreateApprovedUrlPayload): Promise<ApprovedUrl> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/approved-urls/`;
    const response = await httpRequest<any>(url, {
      method: "POST",
      body: JSON.stringify(payload),
    });
    return ApprovedUrl.fromJson(response);
  }
}
